import "$styles/index.css"
import "./particle-flow.js"

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.data('transitions', () => ({
  zoomUpTransition: {
    'x-transition:enter' () { return 'transition ease-out duration-300' },
    'x-transition:enter-start' () { return 'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95' },
    'x-transition:enter-end' () { return 'opacity-100 translate-y-0 sm:scale-100' },
    'x-transition:leave' () { return 'transition ease-in duration-200' },
    'x-transition:leave-start' () { return 'opacity-100 translate-y-0 sm:scale-100' },
    'x-transition:leave-end' () { return 'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95' },
  },
  fadeOpacityTransition: {
    'x-transition:enter' () { return 'transition ease-out duration-300' },
    'x-transition:enter-start' () { return 'opacity-0' },
    'x-transition:enter-end' () { return 'opacity-100' },
    'x-transition:leave' () { return 'transition ease-in duration-200' },
    'x-transition:leave-start' () { return 'opacity-100' },
    'x-transition:leave-end' () { return 'opacity-0' },
  },
  fadeScaleTransition: {
    'x-transition:enter' () { return 'duration-300 ease-out' },
    'x-transition:enter-start' () { return 'opacity-0 scale-95' },
    'x-transition:enter-end' () { return 'opacity-200 scale-100' },
    'x-transition:leave' () { return 'duration-200 ease-in' },
    'x-transition:leave-start' () { return 'opacity-100 scale-100' },
    'x-transition:leave-end' () { return 'opacity-0 scale-95' },
  },
}))
// for homepage hero section
Alpine.data('cascadeStory', () => ({
  step: 6,
  _t: null,
  startStory() {
    if (this._t) return
    const seq = [
      { step: 1, hold: 1000 },
      { step: 2, hold: 1100 },
      { step: 3, hold: 1100 },
      { step: 4, hold: 1100 },
      { step: 5, hold: 900 },
      { step: 6, hold: 1800 },
    ]
    let i = 0
    const tick = () => {
      this.step = seq[i].step
      this._t = setTimeout(() => { i = (i + 1) % seq.length; tick() }, seq[i].hold)
    }
    tick()
  },
}))

// Global platform selection for the tutorial platform switcher (Pipedrive / Close / …).
// Persisted across pages so a reader picks their CRM once. Init order: ?platform= → localStorage → pipedrive.
Alpine.store('platform', {
  current: 'pipedrive',
  supported: ['pipedrive', 'close'],
  // Per-platform RouterJet app host, so shared tutorials can deep-link the
  // reader's selected CRM (Pipedrive → app.routerjet.com, Close →
  // close.routerjet.com). Production hosts on purpose: tutorial deep-links
  // always point at the live app, matching the static fallback href in the
  // markup that no-JS / crawler readers get. Add a host when a platform ships.
  hosts: {
    pipedrive: 'https://app.routerjet.com',
    close: 'https://close.routerjet.com',
  },
  // Build an app URL for the current platform: url('/rules') → host + path.
  url(path = '') {
    return (this.hosts[this.current] || this.hosts.pipedrive) + path
  },
  init() {
    let chosen
    try {
      const fromQuery = new URLSearchParams(window.location.search).get('platform')
      const fromStorage = localStorage.getItem('routerjet:platform')
      chosen = [fromQuery, fromStorage].find((p) => this.supported.includes(p))
    } catch (e) {
      /* URL/localStorage unavailable — fall back to the default */
    }
    if (chosen) this.current = chosen
  },
  select(platform) {
    if (!this.supported.includes(platform)) return
    this.current = platform
    try {
      localStorage.setItem('routerjet:platform', platform)
    } catch (e) {
      /* private mode / storage disabled — selection still works for this page */
    }
  },
})

// /resources platform filter (All / Pipedrive / Close). Progressive enhancement
// layered on the global platform store: the segmented control is x-cloak'd so
// no-JS / crawlers get every group stacked (the baseline), and filtering only
// narrows via x-show — all content stays in the DOM. "All" is a resources-only
// view; picking a real CRM persists site-wide through Alpine.store('platform').
Alpine.data('resourceFilter', () => ({
  filter: 'all',
  init() {
    // Mirror the store's seed order (?platform= → saved pick) but default to the
    // 'all' baseline so the multi-platform index is visible on a first visit.
    const supported = ['pipedrive', 'close']
    try {
      const fromQuery = new URLSearchParams(window.location.search).get('platform')
      const saved = localStorage.getItem('routerjet:platform')
      const chosen = [fromQuery, saved].find((p) => supported.includes(p))
      if (chosen) this.filter = chosen
    } catch (e) {
      /* URL/localStorage unavailable — keep the 'all' baseline */
    }
  },
  select(value) {
    this.filter = value
    // A real CRM pick carries to the rest of the site via the shared store;
    // 'all' leaves any saved pick untouched (it's just a view of this page).
    if (value !== 'all') this.$store.platform.select(value)
  },
  shows(platforms) {
    return this.filter === 'all' || platforms.split(',').includes(this.filter)
  },
}))

Alpine.start()

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
